export const makeChannelName = ({
  name,
  workerVersion,
  portalId
}) => {
  let workerName = name;
  if (portalId) workerName += `#${portalId}`;
  if (workerVersion) workerName += `@${workerVersion}`;
  return workerName;
};